/*MOBILE MENU*/
jQuery(function(){
    //menuCorrect();
    //jQuery(window).resize(function() {
        //menuCorrect(); 
    //});
    jQuery('.open-mobile-menu, .mobile-menu-name').on('click touchend',function(e){
        jQuery('.mobile-menu-container').slideDown(800);
        return false;    
    }); 

    jQuery('.close-mobile-menu').on('click touchend',function(e){
        jQuery('.mobile-menu-container').slideUp(800);
        return false;
    });  
    
    /* TIJDELIJK FAKE SUBMENU */
    jQuery('.mobile-menu-1 a').on('click touchend',function(e){
        var index = jQuery('.mobile-menu-item').index(this);
        var itemCount = jQuery('.mobile-menu-2-content:eq('+index+') a').size();
        
        if(itemCount > 1)
        {               
            jQuery('.mobile-menu-1').animate({left: '-=100%'}, 500);
            jQuery('.mobile-menu-2').animate({left: '0%'}, 800);
            return false;
        }
    }); 
   
    jQuery('.mobile-menu-item').on('click touchend',function(e){
        var index = jQuery('.mobile-menu-item').index(this);
        var html = jQuery('.mobile-menu-2-content:eq('+index+')').html();
        jQuery('.mobile-menu-2').html(html);
    
        jQuery('.mobile-submenu-titel').on('click touchend',function(e){
            jQuery('.mobile-menu-1').animate({left: '0%'}, 800);
            jQuery('.mobile-menu-2').animate({left: '100%'}, 500);        
        });

        jQuery('.subitemwithsubmenu').on('click touchend',function(e){
            var index = jQuery('.subitemwithsubmenu').index(this);
            var html = jQuery('.mobile-menu-3-content:eq('+index+')').html();
            jQuery('.mobile-menu-3').html(html);
            
            jQuery('.mobile-menu-2').animate({left: '-=100%'}, 500);
            jQuery('.mobile-menu-3').animate({left: '0%'}, 800);
            
            jQuery('.mobile-menu-3').find('.mobile-submenu-titel').on('click touchend',function(e){
                jQuery('.mobile-menu-2').animate({left: '0%'}, 800);
                jQuery('.mobile-menu-3').animate({left: '100%'}, 500);        
            });            
            return false;        
        })        
    })
});

/*MOBILE MENU*/



